/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useMemo, useRef } from "react"
import { useGLTF } from "@react-three/drei"
import gsap from "gsap"
import shellsUrl from "./resources/shells-w-material.glb"

export default function Shells(props) {
  const { nodes, materials } = useGLTF(shellsUrl)

  const topMeshRef = useRef(null)
  const hoverTlRef = useRef(null)
  const baseYRef = useRef(0)

  const lift = useMemo(
    () => ({
      height: 0.05,
      upDuration: 1.5,
      downDuration: 1,
      upEase: "expo.out",
      downEase: "power3.out",
    }),
    [],
  )

  useEffect(() => {
    if (!topMeshRef.current) return
    baseYRef.current = topMeshRef.current.position.y
    return () => {
      hoverTlRef.current?.kill()
    }
  }, [])

  const handleEnter = (e) => {
    e.stopPropagation()
    const mesh = topMeshRef.current
    if (!mesh) return

    hoverTlRef.current?.kill()
    gsap.killTweensOf(mesh.position)

    hoverTlRef.current = gsap.timeline().to(mesh.position, {
      y: baseYRef.current + lift.height,
      duration: lift.upDuration,
      ease: lift.upEase,
    })
  }

  const handleLeave = (e) => {
    e.stopPropagation()
    const mesh = topMeshRef.current
    if (!mesh) return

    hoverTlRef.current?.kill()
    gsap.killTweensOf(mesh.position)

    gsap.to(mesh.position, {
      y: baseYRef.current,
      duration: lift.downDuration,
      ease: lift.downEase,
    })
  }

  return (
    <group {...props} dispose={null} onPointerEnter={handleEnter} onPointerLeave={handleLeave}>
      <mesh
        ref={topMeshRef}
        castShadow
        receiveShadow
        geometry={nodes.tripo_node_0493698d.geometry}
        material={materials.Marble}
        position={[0, 1.065, 0]}
        scale={1.14}
      />
      <mesh castShadow receiveShadow geometry={nodes.stand.geometry} material={materials.Marble} position={[-0.001, 0.483, 0]} />
    </group>
  )
}

useGLTF.preload(shellsUrl)
